<template>
  <div class="centerarea-outter">
    <div class="row1">
      <div>
        <border class="border-item">
          <template v-slot:title>
            <customTitle
              class="center-title"
              :showIcon="showIcon"
              text="平台总用户数"
            />
          </template>
          <template v-slot:tabledata>
            <dv-digital-flop :config="userQuantityConfig" />
          </template>
        </border>
      </div>
      <div>
        <border class="border-item">
          <template v-slot:title>
            <customTitle
              class="center-title"
              :showIcon="showIcon"
              text="平台累计教师数"
            />
          </template>
          <template v-slot:tabledata>
            <dv-digital-flop :config="teacherQuantityConfig" />
          </template>
        </border>
      </div>
      <div>
        <border class="border-item">
          <template v-slot:title>
            <customTitle
              class="center-title"
              :showIcon="showIcon"
              text="平台累计学生数"
            />
          </template>
          <template v-slot:tabledata>
            <dv-digital-flop :config="studentQuantityConfig" />
          </template>
        </border>
      </div>
    </div>

    <div class="row2">
      <div>
        <border class="border-item">
          <template v-slot:title>
            <customTitle
              class="center-title"
              :showIcon="showIcon"
              text="平台虚仿资源数"
            />
          </template>
          <template v-slot:tabledata>
            <dv-digital-flop :config="xfQuantityConfig" />
          </template>
        </border>
      </div>
      <div>
        <border class="border-item">
          <template v-slot:title>
            <customTitle
              class="center-title"
              :showIcon="showIcon"
              text="平台课程资源数"
            />
          </template>
          <template v-slot:tabledata>
            <dv-digital-flop :config="courseQuantityConfig" />
          </template>
        </border>
      </div>
      <div>
        <border class="border-item">
          <template v-slot:title>
            <customTitle
              class="center-title"
              :showIcon="showIcon"
              text="平台教学资源数"
            />
          </template>
          <template v-slot:tabledata>
            <dv-digital-flop :config="resourceQuantityConfig" />
          </template>
        </border>
      </div>
    </div>
  </div>
</template>

<script>
import border from "@/components/main/components/border.vue";
import customTitle from "@/components/main/components/title.vue";
import { getSynthesizeDateView } from "@/api/comd.js";
export default {
  components: {
    border,
    customTitle,
  },
  data() {
    return {
      userQuantityConfig: {
        number: [0],
        content: "{nt}",
        textAlign: "left",
        style: {
          fontSize: 50,
          fill: "#fff",
        },
      },
      teacherQuantityConfig: {
        number: [0],
        content: "{nt}",
        textAlign: "left",
        style: {
          fontSize: 50,
          fill: "#fff",
        },
      },
      studentQuantityConfig: {
        number: [0],
        content: "{nt}",
        textAlign: "left",
        style: {
          fontSize: 50,
          fill: "#fff",
        },
      },
      courseQuantityConfig: {
        number: [0],
        content: "{nt}",
        textAlign: "left",
        style: {
          fontSize: 50,
          fill: "#fff",
        },
      },
      resourceQuantityConfig: {
        number: [0],
        content: "{nt}",
        textAlign: "left",
        style: {
          fontSize: 50,
          fill: "#fff",
        },
      },
      xfQuantityConfig: {
        number: [0],
        content: "{nt}",
        textAlign: "left",
        style: {
          fontSize: 50,
          fill: "#fff",
        },
      },
      showIcon: false,
      viewData: {
        userQuantity: 0,
        teacherQuantity: 0,
        studentQuantity: 0,
        courseQuantity: 0,
        resourceQuantity: 0,
        xfQuantity: 0,
      },
    };
  },
  created() {
    let _ = this;
    _.getSynthesizeDateViewHander();
  },
  methods: {
    updateData() {
      this.userQuantityConfig = {
        number: [this.viewData.userQuantity],
        content: "{nt}",
        textAlign: "left",
        style: {
          fontSize: 50,
          fill: "#fff",
        },
      };
      this.teacherQuantityConfig = {
        number: [this.viewData.teacherQuantity],
        content: "{nt}",
        textAlign: "left",
        style: {
          fontSize: 50,
          fill: "#fff",
        },
      };
      this.studentQuantityConfig = {
        number: [this.viewData.studentQuantity],
        content: "{nt}",
        textAlign: "left",
        style: {
          fontSize: 50,
          fill: "#fff",
        },
      };
      this.courseQuantityConfig = {
        number: [this.viewData.courseQuantity],
        content: "{nt}",
        textAlign: "left",
        style: {
          fontSize: 50,
          fill: "#fff",
        },
      };
      this.resourceQuantityConfig = {
        number: [this.viewData.resourceQuantity],
        content: "{nt}",
        textAlign: "left",
        style: {
          fontSize: 50,
          fill: "#fff",
        },
      };
      this.xfQuantityConfig = {
        number: [this.viewData.xfQuantity],
        content: "{nt}",
        textAlign: "left",
        style: {
          fontSize: 50,
          fill: "#fff",
        },
      };
    },
    async getSynthesizeDateViewHander() {
      let res = await getSynthesizeDateView();
      this.viewData.userQuantity = res.data.userQuantity;
      this.viewData.teacherQuantity = res.data.teacherQuantity;
      this.viewData.studentQuantity = res.data.studentQuantity;
      this.viewData.courseQuantity = res.data.courseQuantity;
      this.viewData.resourceQuantity = res.data.resourceQuantity;
      this.viewData.xfQuantity = res.data.xfQuantity;
      this.updateData();
    },
  },
};
</script>

<style scoped>
.dv-digital-flop {
  width: 140px;
  height: 50px;
  margin-top: 15px;
}
.center-title {
  color: #06bbf2;
  font-weight: 700;
}
.border-item {
  width: 210px;
  height: 120px;
}
.row1 {
  width: 100%;
  display: flex;
  flex-flow: row;
  justify-content: space-between;
}

.row2 {
  margin-top: 20px;
  width: 100%;
  display: flex;
  flex-flow: row;
  justify-content: space-between;
}

.centerarea-outter {
  width: 700px;
  height: 300px;
  display: flex;
  flex-flow: column;
  /* justify-content: space-between; */
}
</style>